@if (item) {
  <mat-chip-set>
    @switch (item.status) {
      @case (CIRCULATION_ITEM_STATUS.IN_LIBRARY) {
        <mat-chip class="green-pill">
          Available
        </mat-chip>
      }
      @case (CIRCULATION_ITEM_STATUS.SHELVING) {
        <mat-chip class="green-pill">
          Available
        </mat-chip>
      }
      @case (CIRCULATION_ITEM_STATUS.CHECKED_OUT) {
        <mat-chip class="red-pill">
          Checked Out
        </mat-chip>
      }
      @case (CIRCULATION_ITEM_STATUS.IN_TRANSFER) {
        <mat-chip class="yellow-pill">
          In Transit
        </mat-chip>
      }
      @case (CIRCULATION_ITEM_STATUS.HELD) {
        <mat-chip class="yellow-pill">
          Held
        </mat-chip>
      }
      @case (CIRCULATION_ITEM_STATUS.ON_ORDER) {
        <mat-chip class="blue-pill">
          On Order
        </mat-chip>
      }
      @default {
        <mat-chip class="gray-pill">
          Unavailable
        </mat-chip>
      }
    }
  </mat-chip-set>
}
